import i18n from '@/plugins/i18n';

export const CAPABILITY_CLOUD = 'C';

const TableHeaders = [
  {
    key: 'connectionName',
    name: i18n.global.t('aws.connectionName'),
  },
  {
    key: 'subscriptionId',
    name: i18n.global.t('aws.subscriptionid'),
  },
  {
    key: 'services',
    name: i18n.global.t('aws.services'),
  },
  {
    key: 'updatedAt',
    name: i18n.global.t('aws.date'),
  },
  {
    key: 'createdBy',
    name: i18n.global.t('aws.createdBy'),
  },
  {
    key: 'actionItems',
    name: i18n.global.t('aws.actionItems'),
  },
];

const installationTypes = [
  { id: 'All', name: 'All' },
  { id: 'Manual', name: 'Manual' },
  { id: 'Auto', name: 'Auto' },
];

const allServices = [
  {
    id: 1,
    slug: 'rds',
    isMonitoringEnabled: false,
    title: i18n.global.t('aws.allServicesScreen.rdsTitle'),
    description: i18n.global.t('aws.allServicesScreen.rdsDescription'),
    showAutoInstall: true,
    imgSrc: require(`@/assets/img/aws-rds.png`),
    dataCapturingStatus: false,
  },
  {
    id: 2,
    slug: 'lambda',
    isMonitoringEnabled: false,
    title: i18n.global.t('aws.allServicesScreen.lambdaTitle'),
    description: i18n.global.t('aws.allServicesScreen.lambdaDescription'),
    showAutoInstall: true,
    imgSrc: require(`@/assets/img/aws-lambda.png`),
    dataCapturingStatus: false,
  },
  {
    id: 3,
    slug: 'elasticache',
    isMonitoringEnabled: false,
    title: i18n.global.t('aws.allServicesScreen.elasticCacheTitle'),
    description: i18n.global.t('aws.allServicesScreen.elasticCacheDescription'),
    showAutoInstall: true,
    imgSrc: require(`@/assets/img/aws-elasticache.png`),
    dataCapturingStatus: false,
  },
  // {
  //   id: 4,
  //   slug: 'fargate',
  //   isMonitoringEnabled: false,
  //   title: i18n.global.t('aws.allServicesScreen.fargateTitle'),
  //   description: i18n.global.t('aws.allServicesScreen.fargetDescription'),
  //   showAutoInstall: false,
  //   imgSrc: require(`@/assets/img/aws-fargate.png`),
  //   dataCapturingStatus: false,
  // },
  {
    id: 5,
    slug: 'elb',
    isMonitoringEnabled: false,
    title: i18n.global.t('aws.allServicesScreen.ingressTitle'),
    description: i18n.global.t('aws.allServicesScreen.ingressDescription'),
    showAutoInstall: true,
    imgSrc: require(`@/assets/img/aws-elb.png`),
    dataCapturingStatus: false,
  },
];

const configureableEngines = ['mysql', 'mssql', 'postgres'];

const supportedDatabases = [
  {
    key: 'mysql',
    label: 'MySQL',
    selected: false,
  },
  {
    key: 'mssql',
    label: 'MsSQL',
    selected: false,
  },
  {
    key: 'postgres',
    label: 'Postgres',
    selected: false,
  },
];

const serviceNames = {
  RDS: 'RDS',
  LAMBDA: 'LAMBDA',
  ELB: 'INGRESS',
  ELASTICACHE: 'ELASTICACHE',
};

const SLUG_NAME = {
  RDS: 'AWS RDS',
  LAMBDA: 'AWS lambda',
  ECS_FARGATE: 'AWS fargate ECS',
  ELB: 'AWS ingress',
  ELASTICACHE: 'AWS elasticache',
};

export {
  TableHeaders,
  installationTypes,
  allServices,
  configureableEngines,
  supportedDatabases,
  serviceNames,
  SLUG_NAME,
};
